<template>
  <div class="businessUnitManagement common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">部门名称：</div>
          <div class="content">
            <el-input v-model="form.deptCodeOrName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">业务单元名称：</div>
          <div class="content">
            <el-input v-model="form.unitName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
      <el-button plain @click="exportBtn">导出</el-button>
    </div>
    <commonTable ref="businessUnitTable" />
    <addBusinessUnitDialog
      :add-dialog-show="addDialogShow"
      :row-data="rowData"
      @addBusinessUnitHandle="addBusinessUnitHandle"
      @editBusinessUnitHandle="editBusinessUnitHandle"
      @dialogCloseHandle="dialogCloseHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addBusinessUnitDialog from './component/businessUnitManagement/addBusinessUnitDialog';
import { businessUnitManagementApi } from './service';
import axios from 'axios';
import requestBaseUrl from '@/API/request/baseUrl';

export default {
  data () {
    return {
      form: {},
      addDialogShow: false,
      rowData: {}
    };
  },
  components: {
    commonTable,
    addBusinessUnitDialog
  },
  methods: {
    exportBtn () {
      axios({
        method: 'post',
        headers: {
          sysId: window._env_.VUE_APP_SYSID
        },
        withCredentials: true,
        url: `${requestBaseUrl}/management/bussiness_unit/excel`,
        responseType: 'blob',
        data: this.form
      }).then(response => {
        let date = new Date().format('yyyyMMddhhmmss');
        let fileName = `业务单元${ date }`;
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
        link.target = '_blank';
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    editBusinessUnitHandle (data) {
      businessUnitManagementApi.editBusinessUnit(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.addDialogShow = false;
          this.searchBtn();
        }
      });
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addDialogShow = true;
    },
    addBusinessUnitHandle (data) {
      businessUnitManagementApi.addBusinessUnit(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.addDialogShow = false;
          this.searchBtn();
        }
      });
    },
    dialogCloseHandle () {
      this.addDialogShow = false;
      this.rowData = {};
    },
    addBtn () {
      this.addDialogShow = true;
    },
    deleteHandlen (row) {
      this.$confirm('确定删除此业务单元?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        businessUnitManagementApi.deleteBusinessUnit(row.id).then(res => {
          if (res.status === '200') {
            this.searchBtn();
            this.$message.success('删除成功');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    searchBtn () {
      this.$refs.businessUnitTable.pageData.pageNum = 1;
      this.$refs.businessUnitTable.getTableData({ url: '/management/bussiness_unit/result', params: this.form });
    },
    reset () {
      this.form = {};
      this.searchBtn();
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('业务单元')
          ._width('10%')
          ._data('unitName')
      );
      tableRow.push(
        new TableColumns()
          ._title('对应部门')
          ._width('20%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('所属大区')
          ._width('8%')
          ._data('bigArea')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建人')
          ._width('8%')
          ._data('createUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('6%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      // <el-button type="text" onClick={() => { this.editHandlen(row); }}>
      //   编辑
      // </el-button>
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('8%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.deleteHandlen(row); }}>
                    删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.businessUnitTable.setColumn(column);
      this.$refs.businessUnitTable.loadTable({ url: '/management/bussiness_unit/result', listKey: 'list' });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>
.common_button {
  margin-bottom: 16px;
}
</style>
